<template>
    <div>
        <fluke-card>
            <header v-if="permission.write">
                <div class="title">Editar Categoria</div>
                <div class="description">Edite as informações da categoria</div>
            </header>
            <header v-else>
                <div class="title">Visualizar Categoria</div>
                <div class="description">Alterações desabilitadas para este perfil</div>
            </header>
            <main>
                <v-text-field label="Nome" v-model="category" :disabled="permission.write?null:true"></v-text-field>
            </main>
            <footer v-if="permission.write">
                <fluke-button v-on:click.native="submit">Salvar</fluke-button>
            </footer>
        </fluke-card>

        <div class="right" v-if="permission.write">
            <a v-on:click="remove" class="remove-links">Remover Categoria</a>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

import Card from '../../../components/Main/Content/Card/Card.vue';
import Button from '../../../components/Main/Content/Button/Button.vue';

import permission from '../../../mixins/permissions';

export default {
    mixins: [ permission ],
    components: {
        'fluke-card': Card,
        'fluke-button': Button
    },
    data: function() {
        return {
            id: null,
            category: '',
            permission: {
                read: false,
                write: false
            }
        }
    },
    created: function(){
        this.getData();
        this.permission = this.getUserPagePermission('blog');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
    },
    methods: {
        getData: async function(){
            this.id = this.$route.params.id;
            const result = await axios.get(
				this.$myServerAddresses.blog + 'categories/' + this.id, {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.category = result.data.category;
        },
        submit: async function() {
            const result = await axios.put(
				this.$myServerAddresses.blog + 'categories',
				{
                    id: this.id,
                    category: this.category
				},
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.$router.push({ name: 'blog-categories' });
        },
        remove: async function () {
            const result = await axios.delete(
				this.$myServerAddresses.blog + 'categories/' + this.id,
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.$router.push({ name: 'blog-categories' });
        }
    }
}
</script>
